import { useQuery, useMutation } from 'react-query';
import { getOrganization, updateOrganization } from 'services/organization';

export const useUpdateOrganization = () => useMutation(data => updateOrganization(data));
export const useOrganization = () => useQuery('organization', getOrganization);
